module.exports = function() {
  return new Worker(__webpack_public_path__ + "e9ab3847cd81bb98ba4d.worker.js");
};